import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=6844ad03&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./video.scss?vue&type=style&index=0&id=6844ad03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844ad03",
  null
  
)

export default component.exports